module.exports = __webpack_public_path__ + "static/media/julesMapSearch.b6bafb59.png";